import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const NAV_SECTIONS = [
  {
    items: [{ path: '/', label: 'Dashboard' }],
  },
  {
    title: 'Catalog',
    items: [
      { path: '/products', label: 'Products' },
      { path: '/categories', label: 'Categories' },
    ],
  },
  {
    title: 'Sales',
    items: [
      { path: '/orders', label: 'Orders' },
      { path: '/shipping-zones', label: 'Shipping Zones' },
    ],
  },
  {
    title: 'Customers',
    items: [
      { path: '/users', label: 'Users' },
      { path: '/reviews', label: 'Reviews' },
    ],
  },
  {
    title: 'Storefront',
    items: [
      { path: '/dashboard-manager', label: 'Dashboard Manager' },
      { path: '/campaigns', label: 'Campaigns' },
    ],
  },
  {
    title: 'Support',
    items: [
      { path: '/support-settings', label: 'Support & FAQ' },
      { path: '/support-requests', label: 'Support Requests' },
    ],
  },
  {
    title: 'Configuration',
    items: [{ path: '/settings', label: 'Settings' }],
  },
];

// Sub-routes such as /products/create keep their parent entry highlighted.
const isActivePath = (pathname, path) =>
  path === '/'
    ? pathname === '/'
    : pathname === path || pathname.startsWith(`${path}/`);

const Sidebar = () => {
  const location = useLocation();

  return (
    <aside className="admin-sidebar">
      <nav className="sidebar-nav" aria-label="Admin sections">
        {NAV_SECTIONS.map((section, index) => (
          <div className="nav-section" key={section.title || `section-${index}`}>
            {section.title && (
              <p className="nav-section-title">{section.title}</p>
            )}
            <ul className="nav-list">
              {section.items.map((item) => {
                const active = isActivePath(location.pathname, item.path);
                return (
                  <li key={item.path} className="nav-item">
                    <Link
                      to={item.path}
                      className={`nav-link ${active ? 'active' : ''}`}
                      aria-current={active ? 'page' : undefined}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
